import { PyeongSize as PyeongSizeEnum } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'

import { FilterChip } from './filter-chip'
import { Filter, useFilter } from '../../model/filter'

const PYEONG_SIZES = [
  {
    title: '5평 이하',
    value: PyeongSizeEnum.UNDER_FIVE,
  },
  {
    title: '5평 ~ 10평',
    value: PyeongSizeEnum.FROM_FIVE_TO_TEN,
  },
  {
    title: '10평대',
    value: PyeongSizeEnum.RANGE_TEN,
  },
  {
    title: '20평대',
    value: PyeongSizeEnum.RANGE_TWENTY,
  },
  {
    title: '30평대',
    value: PyeongSizeEnum.RANGE_THIRTY,
  },
  {
    title: '40평 이상',
    value: PyeongSizeEnum.OVER_FORTY,
  },
]

export const PyeongSizes = () => {
  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    filter: { pyeongSizes },
    updateFilter,
  } = useFilter()

  const handlePyeongSizeChange = (value: PyeongSizeEnum) => () => {
    updateFilter({ pyeongSizes: value })
  }

  return (
    <div
      className="p-6 pt-0 pr-4"
      ref={element => {
        if (element) {
          registerScrollElement(Filter.PyeongSizes, element)
        }
      }}
    >
      <h3 className="typo-body1 mb-3 font-semibold text-black">평수</h3>
      <ul className="flex flex-wrap gap-2">
        {PYEONG_SIZES.map(({ title, value }) => (
          <li key={title}>
            <FilterChip
              selected={pyeongSizes.includes(value)}
              onClick={handlePyeongSizeChange(value)}
            >
              {title}
            </FilterChip>
          </li>
        ))}
      </ul>
    </div>
  )
}
